import React, { useState, useEffect } from 'react';
import './App.css';
import DriverAuth from './components/DriverAuth';
import DriverDashboard from './components/DriverDashboard';

function App() {
  const [driver, setDriver] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if driver is already logged in
    const savedDriver = localStorage.getItem('homie_driver');
    if (savedDriver) {
      try {
        const driverData = JSON.parse(savedDriver);
        setDriver(driverData);
      } catch (err) {
        console.error('Failed to parse driver data:', err);
        localStorage.removeItem('homie_driver');
      }
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (driverData) => {
    localStorage.setItem('homie_driver', JSON.stringify(driverData));
    setDriver(driverData);
  };

  const handleLogout = () => {
    localStorage.removeItem('homie_driver');
    setDriver(null);
  };

  if (isLoading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="app">
      {!driver ? (
        <DriverAuth onLogin={handleLogin} />
      ) : (
        <DriverDashboard driver={driver} onLogout={handleLogout} />
      )}
    </div>
  );
}

export default App;
